import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import MultiOfficeRooms2 from '../../../components/Satellites/meetingPoint/MultiOfficeRooms/MultiOfficeRooms2/MultiOfficeRooms2';
import MultiOfficeRooms3 from '../../../components/Satellites/meetingPoint/MultiOfficeRooms/MultiOfficeRooms3/MultiOfficeRooms3';
import MultiOfficeRooms4 from '../../../components/Satellites/meetingPoint/MultiOfficeRooms/MultiOfficeRooms4/MultiOfficeRooms4';
import MultiOfficeRooms5 from '../../../components/Satellites/meetingPoint/MultiOfficeRooms/MultiOfficeRooms5/MultiOfficeRooms5';

class MultiOfficeRooms extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="multi_office_rooms" />
        <ServiceBanner {...this.props} page="multiOfficeRooms" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <MultiOfficeRooms2 {...this.props} />
        <MultiOfficeRooms3 {...this.props} />
        <MultiOfficeRooms4 {...this.props} />
        <MultiOfficeRooms5 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(MultiOfficeRooms);
